import { render } from "./BaseVideoElementcopy.vue?vue&type=template&id=39007b21&scoped=true&ts=true"
import script from "./BaseVideoElementcopy.vue?vue&type=script&lang=ts"
export * from "./BaseVideoElementcopy.vue?vue&type=script&lang=ts"

import "./BaseVideoElementcopy.vue?vue&type=style&index=0&id=39007b21&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39007b21"]])

export default __exports__